import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'wakeUp'

export default function WakeUpPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const selectedValue = formData.get('answer') as string

    if (!selectedValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: t('pages.onboarding.wakeUp.heading', { lng: 'en' }),
      answer_key: selectedValue,
      answer: selectedValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Wake up options
  const getWakeUpOptions = () => [
    {
      value: 'On a tropical beach',
      translationKey: 'pages.onboarding.wakeUp.options.beach',
      emoji: '🏝',
    },
    {
      value: 'In the mountains with fresh air',
      translationKey: 'pages.onboarding.wakeUp.options.mountains',
      emoji: '🏔',
    },
    {
      value: 'In a quiet city apartment',
      translationKey: 'pages.onboarding.wakeUp.options.cityApartment',
      emoji: '🏙',
    },
    {
      value: 'In my own cozy bed',
      translationKey: 'pages.onboarding.wakeUp.options.cozyBed',
      emoji: '🛏',
    },
    {
      value: 'Under the stars in nature',
      translationKey: 'pages.onboarding.wakeUp.options.underStars',
      emoji: '🌌',
    },
    {
      value: 'Not sure yet',
      translationKey: 'pages.onboarding.wakeUp.options.notSure',
      emoji: '🤔',
    },
  ]

  // Get the options
  const options = getWakeUpOptions()

  // Transform options to the format expected by QuestionPage
  const buttons = options.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.wakeUp.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
    />
  )
}
